import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ResponseDTO } from '../dtos/response-dto';
import { AuthenticationService } from '../login/authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        let currentUser: ResponseDTO = this.authenticationService.currentUserValue;
        // const isApiUrl = req.url.startsWith(environment.url + '/private');

        if (currentUser && currentUser.token) {

            let authorities: Array<String> = route.data['authorities'];
            let temRole: boolean = (authorities && currentUser.perfil != null && authorities.indexOf(currentUser.perfil) != -1);

            if (!authorities || !temRole) {
                this.router.navigate(['']);
                return false;
            }

            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['login']);

        return false;
    }
}
